export default __webpack_public_path__ + "static/media/roboto-v27-latin-900.b555d228.woff";